import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

export const DelayedSortAndFilterFetchExperiment = () => (
  <Experiment name="LShop_SRP_Delayed_Sort_And_Filter">
    <ExperimentControl />
    <ExperimentVariant bucket={1} />
  </Experiment>
);
